import {PageLayout} from '@primer/react'
import throttle from 'lodash-es/throttle'
import {useCallback, useEffect, useLayoutEffect, useRef, useState} from 'react'

import {getInitialState} from '../../helpers/initial-state'
import {useWorkflows} from '../../state-providers/workflows/use-workflows'
import {NoSuggestedRepos} from '../side-panel/item-suggestions-list'
import {AutomationGraphView} from './automation-graph-view'
import {AutomationSideNav} from './automation-side-nav'
import styles from './automation-view.module.css'
import {CreateNewWorkflowDialog} from './create-new-workflow-dialog'

export const AutomationView = () => {
  const [noRepoSuggestions, setNoRepoSuggestions] = useState(false)
  const {activeWorkflow} = useWorkflows()
  const [startInEditMode, setStartInEditMode] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const updateOffset = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const offset = rect.top + scrollTop
        containerRef.current.style.setProperty('--pane-top-offset', `${offset}px`)
      }
    }
    updateOffset()

    const throttledUpdateOffset = throttle(updateOffset, 100)
    window.addEventListener('resize', throttledUpdateOffset)
    return () => {
      window.removeEventListener('resize', throttledUpdateOffset)
      throttledUpdateOffset.cancel?.()
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setNoRepoSuggestions(false)
    setStartInEditMode(false)
  }, [activeWorkflow])

  const onNoSuggestedRepositories = useCallback(() => {
    setNoRepoSuggestions(true)
  }, [setNoRepoSuggestions])

  const {projectOwner, isOrganization} = getInitialState()
  const owner = projectOwner?.name?.toLowerCase()

  return (
    <div ref={containerRef} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <PageLayout containerWidth="full" columnGap="none" padding="none" className={styles.PageLayout}>
        {activeWorkflow ? (
          <>
            <PageLayout.Pane aria-label="Workflow List" position="start" className={styles.PageLayoutPane}>
              <AutomationSideNav activeWorkflow={activeWorkflow} />
            </PageLayout.Pane>
            <PageLayout.Content width="full" padding="none">
              {noRepoSuggestions ? (
                <NoSuggestedRepos isOrganization={isOrganization} owner={owner} />
              ) : (
                <AutomationGraphView
                  // set by the create new workflow dialog
                  startInEditMode={startInEditMode}
                  workflow={activeWorkflow}
                  key={activeWorkflow.id}
                  onNoSuggestedRepositories={onNoSuggestedRepositories}
                />
              )}
            </PageLayout.Content>
            <CreateNewWorkflowDialog setStartInEditMode={setStartInEditMode} />
          </>
        ) : (
          <div>No workflows</div>
        )}
      </PageLayout>
    </div>
  )
}
